import { render, staticRenderFns } from "./form-view.vue?vue&type=template&id=0f08b94a"
import script from "./form-view.vue?vue&type=script&lang=js"
export * from "./form-view.vue?vue&type=script&lang=js"
import style0 from "./form-view.vue?vue&type=style&index=0&id=0f08b94a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports